// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__GgYhE","name":"UserMenu_name__3e8KV","text":"UserMenu_text__3m5R_","avatar":"UserMenu_avatar__2e7Jj","button":"UserMenu_button__3mTE-"};